// Copyright 2023 The Perses Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { Kind } from './kind';

export function isProjectMetadata(metadata: Metadata | ProjectMetadata): metadata is ProjectMetadata {
  return 'project' in metadata;
}

export interface Metadata {
  name: string;
  createdAt?: string;
  updatedAt?: string;
  version?: number;
}

export interface ProjectMetadata extends Metadata {
  project: string;
}

export interface Resource {
  kind: Kind;
  metadata: Metadata | ProjectMetadata;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  spec: any;
}

export function getMetadataProject(metadata: ProjectMetadata | Metadata): string | undefined {
  return 'project' in metadata ? metadata.project : undefined;
}
